import React from 'react';
import { Reveal } from './Reveal';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  theme?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  theme = 'light'
}: SectionHeadingProps) {
  const isCenter = align === 'center';
  return <Reveal className={`${isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}`} data-id="element-294" data-mp="3k29mad1ioj2g">
      {eyebrow ? <p className="mb-3 font-display text-xs font-bold uppercase tracking-[0.18em] text-brand-500" data-id="element-295" data-mp="bmpwxp3yvkso">
          {eyebrow}
        </p> : null}
      <h2 className={`font-display text-3xl font-extrabold leading-[1.1] sm:text-4xl lg:text-[48px] ${theme === 'dark' ? 'text-white' : 'text-ink'}`} data-id="element-296" data-mp="1tip7xlr7spf">
        {title}
      </h2>
      {subtitle ? <p className={`mt-4 text-base leading-relaxed sm:text-lg ${theme === 'dark' ? 'text-white/70' : 'text-[#5B5B5B]'}`} data-id="element-297" data-mp="uh4wbfu6xfh1">
          {subtitle}
        </p> : null}
    </Reveal>;
}